export default __webpack_public_path__ + "media/images/portfolio/width-1200/portfolio-4-089733410fb6ec90dd002a51e5d87b36.jpg";